__webpack_require__.p = "https://metaworks-lingyunguang.obs.cn-north-4.myhuaweicloud.com/metaworks/h5/prod/";